import {PlatformDetection} from "../device/platform-detection";
import {RawLocalStorageKeys} from "../storage/raw-local-storage/raw-local-storage-keys";

export class LayoutDetection {
    constructor() {
        this._platformDetection = new PlatformDetection();
    }

    private readonly _platformDetection: PlatformDetection;

    private get shouldForceHybridLayout(): boolean {
        return localStorage.getItem(RawLocalStorageKeys.forceHybridLayout) === 'true';
    }

    get shouldUseWebappLayout(): boolean {
        return this._platformDetection.isWeb && !this.shouldForceHybridLayout;
    }
}
